import { render, staticRenderFns } from "./ControlEditAppeal.vue?vue&type=template&id=25f0671c&scoped=true"
import script from "./ControlEditAppeal.vue?vue&type=script&lang=js"
export * from "./ControlEditAppeal.vue?vue&type=script&lang=js"
import style0 from "./ControlEditAppeal.vue?vue&type=style&index=0&id=25f0671c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0671c",
  null
  
)

export default component.exports